<template>
  <section>
    <div class="group-inline">
      <label>Fill</label>
      <button
        class="btn-colour"
        :style="`background-color: ${value.fill}`"
        @click="colourWidget === 'fill' ? colourWidget = '' : colourWidget = 'fill'"
      ></button>
    </div>
    <div class="mb-2">
      <verte v-if="colourWidget === 'fill'" display="widget" picker="square" model="rgb" v-model="value.fill"></verte>
    </div>
    <div class="group-inline">
      <label>Stroke</label>
      <button
        class="btn-colour"
        :style="`background-color: ${value.stroke}`"
        @click="colourWidget === 'stroke' ? colourWidget = '' : colourWidget = 'stroke'"
      ></button>
    </div>
    <div class="mb-2">
      <verte v-if="colourWidget === 'stroke'" display="widget" picker="square" model="rgb" v-model="value.stroke"></verte>
    </div>
    <div class="group-inline">
      <label>Stroke Width</label>
      <input class="group-inline__input" id="strokeWidth" type="number" max="20" min="0" v-model.number="value.strokeWidth">
    </div>
    <div class="group-inline">
      <label>Drop Shadow</label>
      <input class="group-inline__input" type="checkbox" :checked="value.dropShadow" @change="value.dropShadow = $event.target.checked">
    </div>
  </section>
</template>
<script>
import Verte from 'verte'
import 'verte/dist/verte.css'

export default {
  props: ['value'],

  components: {
    Verte,
  },

  data () {
    return {
      colourWidget: ''
    }
  },
}
</script>
<style lang="scss" scoped>
.group-inline {
  align-items: center;
  display: flex;
  margin-bottom: 14px;

  label {
    margin: auto auto auto 0;
  }

  &__input {
    background-color: #fbfcfe;
    border: 1px solid rgba(96, 125, 159, 0.25);
    border-radius: 3px;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    font-size: 11px;
    margin: 0 0 0 10px;
    overflow: hidden;
    padding: 4px 5px;
  }
}

.group-block {
  align-items: center;
  display: flex;
  margin-bottom: 14px;

  label {
    margin: auto auto auto 0;
  }

  &__inputs {
    display: flex;
    flex-wrap: wrap;
    width: 152px;
  }

  &__input-wrapper {
    width: 50%;
  }

  &__input {
    background-color: #fbfcfe;
    border: 1px solid rgba(96, 125, 159, 0.25);
    border-radius: 3px;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    font-size: 11px;
    margin: 0;
    overflow: hidden;
    padding: 4px 5px;
    width: 100%;
  }
}

.btn-colour {
  border: 1px solid #111;
  border-radius: 3px;
  width: 22px;
  height: 22px;
}

.btn-xs {
  padding: 0.25rem 0.35rem;
  font-size: 0.75rem;
  line-height: 1.25;
  border-radius: 0.2rem;
}
</style>

